<template>
  <main class="main">
    <div class="content container">
      <h1 v-if="sendingRequest" class="heading-reset">
        Пожалуйста подождите...
      </h1>
      <div v-else-if="isStatusOk">
        <h1 class="heading-reset">
          Регистрация подтверждена!
        </h1>
        <p class="p-reset">Через некоторое время с&nbsp;вами свяжется наш&nbsp;менеджер.</p>
        <p class="p-reset">Также вы&nbsp;можете перейти в&nbsp;свой <router-link class="link link-reset" :to="{ name: 'personal' }">личный&nbsp;кабинет</router-link></p>
      </div>
      <h1 v-else class="heading-reset">
        Ошибка активации.
      </h1>
    </div>
  </main>
</template>

<style scoped>
.main {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 80vh;
  text-align: center;
}

p {
  font-weight: 500;
  line-height: 120%;
}

p:not(:last-child) {
  margin-bottom: 10px;
}

h1 {
  margin-bottom: 30px;
  line-height: 120%;
}

.link {
  color: var(--main-active);
  text-decoration: underline;
  transition: color .2s linear;
}

.link:hover {
  color: var(--main);
}
</style>

<script>
import { API_BASE_URL } from '@/config.js'

export default {
  data () {
    return {
      isStatusOk: true,
      sendingRequest: false
    }
  },
  methods: {
    async doActivate () {
      const response = await fetch(`${API_BASE_URL}/api/user/activate`, {
        method: 'POST',
        body: JSON.stringify({
          hash: this.$route.params.hash
        }),
        headers: {
          'Content-Type': 'application/json'
        }
      })

      return response.status
    }
  },
  async created () {
    this.sendingRequest = true
    try {
      const status = await this.doActivate()
      this.sendingRequest = false
      this.isStatusOk = status === 201
    } catch {
      this.sendingRequest = false
      this.isStatusOk = false
    }
  }
}
</script>
